import {Model, Signal, View} from "@lernetz/ts-lib"
import template from "./Topics.html";

export class Topics extends View {

    constructor() {
        super({ template, data: new TopicsController()})
    }

}

class TopicsController extends Model {
    // inputs
    public topics;
    choice: Signal<unknown>;
    active: any;

    constructor() {
        super();
        this.choice = new Signal();
    }

    choose(item) {
        if (window.innerWidth < 768) {
            document.querySelector('#topics').scrollIntoView({
                behavior: 'smooth'
            });
        }
        this.choice.dispatch(item);
    }

}
